module.exports = __webpack_public_path__ + "static/privateschool-ba91f0e81881191a6a6e0d003dacdc01.jpg";